import { EventConstructorArgs } from '@linktr.ee/event-lib/envelope/Event';
import { useEffect } from 'react';
import { publishEvent, publishNonGoldenEvent } from './client';
import { createPageViewedEvent, createScreenViewedEvent } from './events';

const INITIAL_ANALYTICS_DELAY_MS = 250;

const reportInitialAnalyticsError = (error: unknown): void => {
  // eslint-disable-next-line no-console
  console.info('analytics:pushInitialEvents failed', error);
};

const safelyPublishInitialAnalyticsEvent = (callback: () => void): void => {
  try {
    callback();
  } catch (error) {
    reportInitialAnalyticsError(error);
  }
};

const scheduleInitialAnalyticsEvent = (callback: () => void): void => {
  if (typeof window === 'undefined') {
    safelyPublishInitialAnalyticsEvent(callback);
    return;
  }

  window.setTimeout(
    () => safelyPublishInitialAnalyticsEvent(callback),
    INITIAL_ANALYTICS_DELAY_MS
  );
};

export const usePublishScreenViewedEvent = (
  screenTitle: EventConstructorArgs<
    'ScreenViewedGolden',
    '14-13-0'
  >['payload']['screen']['screenTitle'],
  enabled = true
) => {
  useEffect(() => {
    if (!enabled) {
      return;
    }
    const event = createScreenViewedEvent(screenTitle);

    scheduleInitialAnalyticsEvent(() => {
      publishEvent(event);
    });
  }, [enabled, screenTitle]);
};

export const usePublishPageViewedEvent = (enabled = true) => {
  useEffect(() => {
    if (!enabled) {
      return;
    }
    // TODO: we need to figure out how to detect mobile app webview with Descope
    // one Auth0, we only push PageViewed events when not in mobile app webview
    try {
      const event = createPageViewedEvent();

      if (event) {
        scheduleInitialAnalyticsEvent(() => {
          publishNonGoldenEvent(event);
        });
      }
    } catch (error) {
      reportInitialAnalyticsError(error);
    }
  }, [enabled]);
};
